import { PLATFORM } from "aurelia-pal";
import { inject } from "aurelia-framework";
import { DialogService, DialogCloseResult } from "aurelia-dialog";
import { I18N } from "aurelia-i18n";

@inject(DialogService, I18N)
export class DialogFactory {
  constructor(
    private service: DialogService,
    private i18n: I18N,
  ) {}

  /** open a modal error dialog with the given message and an (optional) title. */
  openError(message: string, title?: string): Promise<boolean> {
    return this.openMessageDialog(
      "error",
      message,
      title || this.i18n.tr("components.k-message-dialog.error"),
    );
  }

  /** open a modal ok/cancel dialog with the given message and an (optional) title. */
  openOkCancel(message: string, title?: string): Promise<boolean> {
    return this.openMessageDialog(
      "okcancel",
      message,
      title || this.i18n.tr("components.k-message-dialog.question"),
    );
  }

  private async openMessageDialog(
    mode: string,
    message: string,
    title?: string,
  ): Promise<boolean> {
    const d = await this.open(
      PLATFORM.moduleName("components/k-message-dialog"),
      {
        mode: mode,
        message: message,
        title: title,
      },
    );
    return !d.wasCancelled;
  }

  /** generic dialog method */
  open(viewModel: string, model: any): Promise<DialogCloseResult> {
    return this.service
      .open({
        viewModel: viewModel,
        model: model,
        enableEscClose: true,
        // lock=true means: don't allow closing with ESC or clicking outside
        // the dialog; instead a button _must_ be clicked. Therefore we
        // set lock=false.
        lock: false,
      })
      .whenClosed();
  }
}
